// extracted by mini-css-extract-plugin
export var aircallIframe = "_dh-3";
export var fabContainer = "_dh-5";
export var fabRinging = "_dh-6";
export var loadingOverlay = "_dh-4";
export var pulse = "_dh-7";
export var widgetContent = "_dh-2";
export var widgetPanel = "_dh-0";
export var widgetPanelExpanded = "_dh-1";